module.exports = __webpack_public_path__ + "img/vn.855b5073.svg";